import { render, staticRenderFns } from "./AgeConfirmation.vue?vue&type=template&id=67288b51&"
import script from "./AgeConfirmation.vue?vue&type=script&lang=ts&"
export * from "./AgeConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports